<!-- Policy -->
<div>
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "generalOptions.title" | translate }}
  </span>
</div>
<!-- Formula -->
<div
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2"
  *ngIf="isConfort">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.formula" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="formulaValues"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PackageId, hasEndorsementWait4Sign)
        "
        [(ngModel)]="policyDetailsCopy.formulasAndOptionsInformations.formulaId"
        appendTo="body"
        [styleClass]="
          getDropdownClass(
            formulaHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PackageId, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onFormulaChanged()"
        optionLabel="label"
        optionValue="id"></p-dropdown>
    </div>
  </div>
</div>
<!-- Formula not editable -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.OBJVAL) && !isConfort"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.formula" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.formulasAndOptionsInformations.formulaName"
        [disabled]="true"
        pInputText
        type="text"
        class="disabled-inputtext w-full"
        [placeholder]="'generalOptions.placeholder' | translate" />
    </div>
  </div>
</div>

<!-- Valuable Object -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.OBJVAL) && isConfort"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.valuableObject" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="valuableObjectOptions"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.OBJVAL, hasEndorsementWait4Sign)
        "
        [(ngModel)]="policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value"
        appendTo="body"
        [styleClass]="
          getDropdownClass(
            valuableObjectHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.OBJVAL, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onValuableObjectChange()"
        optionLabel="label"
        optionValue="value"></p-dropdown>
    </div>
  </div>
</div>
<!-- NO Valuable Object -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.OBJVAL) && !isConfort"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.valuableObject" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [ngModel]="
          policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value
            | currency: 'EUR' : 'symbol' : '1.0' : 'fr'
        "
        [disabled]="true"
        pInputText
        type="text"
        [ngClass]="getNonEditableInputClass(valuableObjectHasChanged) + ' w-full'"
        [placeholder]="'generalOptions.placeholder' | translate" />
    </div>
  </div>
</div>

<!-- NO Valuable Object -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.OBJVAL)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.valuableObject" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="noValuableObject"
        [disabled]="true"
        pInputText
        type="text"
        [ngClass]="getNonEditableInputClass(valuableObjectHasChanged) + ' w-full'"
        [placeholder]="'generalOptions.placeholder' | translate" />
    </div>
  </div>
</div>
<!-- CAP_MOB -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.CAP_MOB)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.capital" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [ngModel]="getCapitalMobilier() | currency: 'EUR' : 'symbol' : '1.0' : 'fr'"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.CAP_MOB, hasEndorsementWait4Sign)
        "
        pInputText
        type="text"
        [ngClass]="getNonEditableInputClass(capMobHasChanged) + ' w-full'"
        [placeholder]="'optionsList.capitalPlaceholder' | translate"
        (ngModelChange)="onCapMobChange()" />
    </div>
  </div>
</div>
<!--Options souscrites ou non-->
<div *ngFor="let item of policyDetailsCopy.formulasAndOptionsInformations.options">
  <!-- Protection Juridique -->
  <!-- <ng-container
    *ngIf="
      (item.type === options.PJ || item.type === options.PJSOL) &&
      getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PJ)
    ">
    <div class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "optionsList.PJOption" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <p-dropdown
            [options]="yesNoValues"
            [(ngModel)]="item.isSelected"
            [disabled]="
              !getIsOptionEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PJ, hasEndorsementWait4Sign, preventOptionSubscription, item.isSelected)
            "
            appendTo="body"
            [styleClass]="
              getDropdownClass(
                PJSOLHasChanged,
                getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PJ, hasEndorsementWait4Sign)
              ) + ' w-full'
            "
            (ngModelChange)="onPJSOLHasChanged()"></p-dropdown>
        </div>
      </div>
    </div>
  </ng-container> -->
  <!-- Assurance Scolaire -->
  <ng-container
    *ngIf="item.type === options.RCS && getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.RCS)">
    <div class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "optionsList.schoolOption" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <p-dropdown
            [options]="yesNoValues"
            [(ngModel)]="item.isSelected"
            appendTo="body"
            [disabled]="
              !getIsOptionEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.RCS, hasEndorsementWait4Sign, preventOptionSubscription, item.isSelected)
            "
            [styleClass]="
              getDropdownClass(
                RCSHasChanged,
                getIsOptionEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.RCS, hasEndorsementWait4Sign, preventOptionSubscription, item.isSelected)
              ) + ' w-full'
            "
            (ngModelChange)="onRCSHasChanged()"></p-dropdown>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- OPTION PJ -->
  <ng-container
    *ngIf="
      item.type === options.PJ &&
      getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PJ) &&
      !!defaultPjValue
    ">
    <div class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "optionsList.bikeOption" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <p-dropdown
            [options]="yesNoValues"
            [(ngModel)]="item.isSelected"
            appendTo="body"
            [disabled]="
              !getIsOptionEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PJ, hasEndorsementWait4Sign, preventOptionSubscription, item.isSelected)
            "
            [styleClass]="
              getDropdownClass(
                PjHasChanged,
                getIsOptionEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.PJ, hasEndorsementWait4Sign, preventOptionSubscription, item.isSelected)
              ) + ' w-full'
            "
            (ngModelChange)="onPJHasChanged()"></p-dropdown>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- OPTION VAN -->
  <ng-container
    *ngIf="
      item.type === options.VAN &&
      getIsVisible(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.VAN) &&
      !!defaultVanValue
    ">
    <div class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
      <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "optionsList.bikeOption" | translate }}
        </span>
      </div>
      <div class="flex items-center w-full sm:w-1/2 p-1">
        <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
          <p-dropdown
            [options]="yesNoValues"
            [(ngModel)]="item.isSelected"
            appendTo="body"
            [disabled]="
              !getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.VAN, hasEndorsementWait4Sign)
            "
            [styleClass]="
              getDropdownClass(
                VanHasChanged,
                getIsEditable(policyFieldsVM, PolicyFields.FOROPTTARIF, ForOptTarif.VAN, hasEndorsementWait4Sign)
              ) + ' w-full'
            "
            (ngModelChange)="onVANHasChanged()"></p-dropdown>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Bailleur -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.OptionalServiceId) &&
    qualiteOccupant === QualiteOccupant.Locataire
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.sendCertificate" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="yesNoValues"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.OptionalServiceId,
            hasEndorsementWait4Sign
          )
        "
        [(ngModel)]="policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption"
        appendTo="body"
        [styleClass]="
          getDropdownClass(
            bailleurHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.OptionalServiceId,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        (ngModelChange)="onBailleurHasChanged()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Bailleur Non Editable -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.OptionalServiceId) &&
    qualiteOccupant === QualiteOccupant.Proprietaire
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.sendCertificate" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [ngModel]="getBailleurValue()"
        [disabled]="true"
        pInputText
        type="text"
        class="disabled-inputtext w-full"
        [placeholder]="'generalOptions.placeholder' | translate" />
    </div>
  </div>
</div>
